// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ProjectHeader_ProjectFragmentDoc } from '../../ProjectHeader.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GuidedChangeEventPage_ChangeEventQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
  structureId: Types.Scalars['ID']['input'];
}>;


export type GuidedChangeEventPage_ChangeEventQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, title: string, internalNote?: string | null | undefined, hasPreSignedContract: boolean, status: Types.ChangeEventStatus, document?: { __typename?: 'Document', id: string, name: string } | null | undefined, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType }, workflow?: { __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow } | null | undefined, reason: { __typename?: 'ChangeEventReason', id: string }, projectStage: { __typename?: 'ProjectStage', id: string }, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string }
      | { __typename?: 'PlanPackage', id: string }
      | { __typename?: 'DesignPackage', id: string }
      | { __typename?: 'ProductOffering', id: string }
     | null | undefined, configChange?: { __typename?: 'ChangeEventConfigChange', id: string, target?: { __typename?: 'CheckoutConfig', id: string } | null | undefined, result: { __typename?: 'CheckoutConfig', id: string, config: { __typename?: 'CheckoutConfigSide', options: Array<{ __typename?: 'CheckoutConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } }> } } } | null | undefined, materialVariantSwaps: Array<{ __typename?: 'ChangeEventMaterialVariantSwap', id: string, isPlanBasedSwap: boolean, proposedMaterialVariantWasCreated: boolean, totalCostInCents: number, totalPriceInCents: number, originalProjectItem: { __typename?: 'ProjectItem', id: string }, proposedMaterialVariant: { __typename?: 'MaterialVariant', id: string }, proposedTradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined }> } };

export type GuidedChangeEventPage_ProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GuidedChangeEventPage_ProjectQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Region', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Market', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Community', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Subdivision', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Lot', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Structure', id: string, isAdu: boolean, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Unit', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, siblingProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
   };

export type GuidedChangeEventPage_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, siblingProjects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export type GuidedChangeEventPage_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, siblingProjects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export type GuidedChangeEventPage_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, siblingProjects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export type GuidedChangeEventPage_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, siblingProjects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export type GuidedChangeEventPage_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, siblingProjects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export type GuidedChangeEventPage_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, siblingProjects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export type GuidedChangeEventPage_Project_Structure_Fragment = { __typename?: 'Structure', id: string, isAdu: boolean, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, siblingProjects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export type GuidedChangeEventPage_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined, latestActiveStage?: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } | null | undefined, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, siblingProjects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export type GuidedChangeEventPage_ProjectFragment =
  | GuidedChangeEventPage_Project_StandaloneProject_Fragment
  | GuidedChangeEventPage_Project_Region_Fragment
  | GuidedChangeEventPage_Project_Market_Fragment
  | GuidedChangeEventPage_Project_Community_Fragment
  | GuidedChangeEventPage_Project_Subdivision_Fragment
  | GuidedChangeEventPage_Project_Lot_Fragment
  | GuidedChangeEventPage_Project_Structure_Fragment
  | GuidedChangeEventPage_Project_Unit_Fragment
;

export type GuidedChangeEventPage_ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, title: string, internalNote?: string | null | undefined, hasPreSignedContract: boolean, status: Types.ChangeEventStatus, document?: { __typename?: 'Document', id: string, name: string } | null | undefined, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType }, workflow?: { __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow } | null | undefined, reason: { __typename?: 'ChangeEventReason', id: string }, projectStage: { __typename?: 'ProjectStage', id: string }, readyPlan?:
    | { __typename?: 'ReadyPlan', id: string }
    | { __typename?: 'PlanPackage', id: string }
    | { __typename?: 'DesignPackage', id: string }
    | { __typename?: 'ProductOffering', id: string }
   | null | undefined, configChange?: { __typename?: 'ChangeEventConfigChange', id: string, target?: { __typename?: 'CheckoutConfig', id: string } | null | undefined, result: { __typename?: 'CheckoutConfig', id: string, config: { __typename?: 'CheckoutConfigSide', options: Array<{ __typename?: 'CheckoutConfigOption', id: string, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } }> } } } | null | undefined, materialVariantSwaps: Array<{ __typename?: 'ChangeEventMaterialVariantSwap', id: string, isPlanBasedSwap: boolean, proposedMaterialVariantWasCreated: boolean, totalCostInCents: number, totalPriceInCents: number, originalProjectItem: { __typename?: 'ProjectItem', id: string }, proposedMaterialVariant: { __typename?: 'MaterialVariant', id: string }, proposedTradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined }> };

export const GuidedChangeEventPage_ProjectFragmentDoc = gql`
    fragment GuidedChangeEventPage_Project on Project {
  ...ProjectHeader_Project
  ... on Structure {
    id
    isAdu
  }
  readyPlanConfig {
    id
  }
  latestActiveStage {
    id
    hasSignedContract
  }
}
    ${ProjectHeader_ProjectFragmentDoc}`;
export const GuidedChangeEventPage_ChangeEventFragmentDoc = gql`
    fragment GuidedChangeEventPage_ChangeEvent on ChangeEvent {
  id
  title
  internalNote
  hasPreSignedContract
  document {
    id
    name
  }
  status
  type {
    code
  }
  workflow {
    code
  }
  reason {
    id
  }
  projectStage {
    id
  }
  readyPlan {
    id
  }
  configChange {
    id
    target {
      id
    }
    result {
      id
      config: sideFor(structureId: $structureId) {
        options {
          id
          readyPlanOption {
            id
          }
        }
      }
    }
  }
  materialVariantSwaps {
    id
    isPlanBasedSwap
    proposedMaterialVariantWasCreated
    totalCostInCents
    totalPriceInCents
    originalProjectItem {
      id
    }
    proposedMaterialVariant {
      id
    }
    proposedTradePartner {
      id
    }
  }
}
    `;
export const GuidedChangeEventPage_ChangeEventDocument = gql`
    query GuidedChangeEventPage_ChangeEvent($changeEventId: ID!, $structureId: ID!) {
  changeEvent(id: $changeEventId) {
    ...GuidedChangeEventPage_ChangeEvent
  }
}
    ${GuidedChangeEventPage_ChangeEventFragmentDoc}`;

/**
 * __useGuidedChangeEventPage_ChangeEventQuery__
 *
 * To run a query within a React component, call `useGuidedChangeEventPage_ChangeEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuidedChangeEventPage_ChangeEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuidedChangeEventPage_ChangeEventQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGuidedChangeEventPage_ChangeEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables> & ({ variables: GuidedChangeEventPage_ChangeEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>(GuidedChangeEventPage_ChangeEventDocument, options);
      }
export function useGuidedChangeEventPage_ChangeEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>(GuidedChangeEventPage_ChangeEventDocument, options);
        }
// @ts-ignore
export function useGuidedChangeEventPage_ChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>;
export function useGuidedChangeEventPage_ChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GuidedChangeEventPage_ChangeEventQuery | undefined, GuidedChangeEventPage_ChangeEventQueryVariables>;
export function useGuidedChangeEventPage_ChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>(GuidedChangeEventPage_ChangeEventDocument, options);
        }
export type GuidedChangeEventPage_ChangeEventQueryHookResult = ReturnType<typeof useGuidedChangeEventPage_ChangeEventQuery>;
export type GuidedChangeEventPage_ChangeEventLazyQueryHookResult = ReturnType<typeof useGuidedChangeEventPage_ChangeEventLazyQuery>;
export type GuidedChangeEventPage_ChangeEventSuspenseQueryHookResult = ReturnType<typeof useGuidedChangeEventPage_ChangeEventSuspenseQuery>;
export type GuidedChangeEventPage_ChangeEventQueryResult = ApolloReactCommon.QueryResult<GuidedChangeEventPage_ChangeEventQuery, GuidedChangeEventPage_ChangeEventQueryVariables>;
export const GuidedChangeEventPage_ProjectDocument = gql`
    query GuidedChangeEventPage_Project($projectId: ID!) {
  project(id: $projectId) {
    ...GuidedChangeEventPage_Project
  }
}
    ${GuidedChangeEventPage_ProjectFragmentDoc}`;

/**
 * __useGuidedChangeEventPage_ProjectQuery__
 *
 * To run a query within a React component, call `useGuidedChangeEventPage_ProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuidedChangeEventPage_ProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuidedChangeEventPage_ProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGuidedChangeEventPage_ProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GuidedChangeEventPage_ProjectQuery, GuidedChangeEventPage_ProjectQueryVariables> & ({ variables: GuidedChangeEventPage_ProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GuidedChangeEventPage_ProjectQuery, GuidedChangeEventPage_ProjectQueryVariables>(GuidedChangeEventPage_ProjectDocument, options);
      }
export function useGuidedChangeEventPage_ProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuidedChangeEventPage_ProjectQuery, GuidedChangeEventPage_ProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GuidedChangeEventPage_ProjectQuery, GuidedChangeEventPage_ProjectQueryVariables>(GuidedChangeEventPage_ProjectDocument, options);
        }
// @ts-ignore
export function useGuidedChangeEventPage_ProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GuidedChangeEventPage_ProjectQuery, GuidedChangeEventPage_ProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GuidedChangeEventPage_ProjectQuery, GuidedChangeEventPage_ProjectQueryVariables>;
export function useGuidedChangeEventPage_ProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GuidedChangeEventPage_ProjectQuery, GuidedChangeEventPage_ProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GuidedChangeEventPage_ProjectQuery | undefined, GuidedChangeEventPage_ProjectQueryVariables>;
export function useGuidedChangeEventPage_ProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GuidedChangeEventPage_ProjectQuery, GuidedChangeEventPage_ProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GuidedChangeEventPage_ProjectQuery, GuidedChangeEventPage_ProjectQueryVariables>(GuidedChangeEventPage_ProjectDocument, options);
        }
export type GuidedChangeEventPage_ProjectQueryHookResult = ReturnType<typeof useGuidedChangeEventPage_ProjectQuery>;
export type GuidedChangeEventPage_ProjectLazyQueryHookResult = ReturnType<typeof useGuidedChangeEventPage_ProjectLazyQuery>;
export type GuidedChangeEventPage_ProjectSuspenseQueryHookResult = ReturnType<typeof useGuidedChangeEventPage_ProjectSuspenseQuery>;
export type GuidedChangeEventPage_ProjectQueryResult = ApolloReactCommon.QueryResult<GuidedChangeEventPage_ProjectQuery, GuidedChangeEventPage_ProjectQueryVariables>;